/**
 * MockDetector Widget Configuration
 * Centralized config for environment-specific settings
 */

// Get Supabase URL from environment or fallback
const getSupabaseUrl = (): string => {
  // Check for environment variable first
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_URL) {
    return import.meta.env.VITE_SUPABASE_URL;
  }
  
  // Fallback to production URL
  return 'https://tzowmzqfbicbyvikhdwy.supabase.co';
};

export const WIDGET_CONFIG = {
  SUPABASE_URL: getSupabaseUrl(),
  
  // Edge Function Endpoints
  get RECORD_SCAN_ENDPOINT() {
    return `${this.SUPABASE_URL}/functions/v1/record-scan`;
  },
  
  get REPORT_SCAN_RESULT_ENDPOINT() {
    return `${this.SUPABASE_URL}/functions/v1/report-scan-result`;
  },
  
  get SUBMIT_FEEDBACK_ENDPOINT() {
    return `${this.SUPABASE_URL}/functions/v1/submit-feedback`;
  },
  
  get VALIDATE_KEY_ENDPOINT() {
    return `${this.SUPABASE_URL}/functions/v1/validate-mockdetector-key`;
  },
  
  get HEARTBEAT_ENDPOINT() {
    return `${this.SUPABASE_URL}/functions/v1/widget-heartbeat`;
  },
  
  // Widget Settings
  DEFAULT_STORAGE_PREFIX: 'mockdetector',
  
  // Branding
  PRODUCT_NAME: 'MockDetector Pro',
};
